module.exports = __webpack_public_path__ + "assets/img/41748f7b158cb73291c6cf5d2cf45d7d.png";